export function showToast(message, level = 'error') {
  const template = document.querySelector(`template[data-toast-template="${level}"]`);
  if (!template) return;

  const toast = template.content.firstElementChild.cloneNode(true);
  toast.querySelector('.toast-message').textContent = message;
  (document.querySelector('[data-toast-container]') || document.body).append(toast);
}
